import { render, staticRenderFns } from "./SALocations.vue?vue&type=template&id=71e9b170&scoped=true"
import script from "./SALocations.vue?vue&type=script&lang=js"
export * from "./SALocations.vue?vue&type=script&lang=js"
import style0 from "./SALocations.vue?vue&type=style&index=0&id=71e9b170&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e9b170",
  null
  
)

export default component.exports